<app-section-loader [loading]="loading"></app-section-loader>
<h2 class="mat-dialog-title" mat-dialog-title class="text-secondary">
  {{ importPhase === 3 ? "Imported Student Report" : "Import Students" }}
</h2>
<div *ngIf="importPhase === 1">
  <mat-dialog-content>
    <div class="form-group">
      <div class="label">
        Upload from file
        <small class="text-danger">(Accepted file format - .xlsx) * </small>
      </div>
      <div class="file-upload">
        <input
          #fileInput
          type="file"
          accept=".xlsx"
          id="file"
          (change)="onUpload($event)"
          style="visibility: hidden"
        />
        <div class="file-upload-text">
          {{ fileName ? fileName : "Select a file" }}
        </div>
        <button mat-raised-button color="primary" (click)="fileInput.click()">
          Browse
        </button>
      </div>
    </div>
    <div class="template-download mb-3">
      <a
        href="https://hugdevs3.s3.amazonaws.com/Templates/Student_Template.xlsx"
        download
        >Download a blank template</a
      >
    </div>
    <p class="mb-1">Choose a school for which you are uploading students:</p>
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Schools</mat-label>
      <mat-select (selectionChange)="schoolSelected($event)" required>
        <mat-option>
          <ngx-mat-select-search
            style="width: 100%"
            [formControl]="schoolControl"
            [noEntriesFoundLabel]="'No matching School found'"
            placeholderLabel="Search School"
          >
          </ngx-mat-select-search>
        </mat-option>
        <mat-option *ngFor="let school of schoolOptions" [value]="school.id">
          {{ school.school_name }}
          {{ school.uuid ? "(" + school.uuid + ")" : "" }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Cancel</button>
    <button
      mat-raised-button
      color="primary"
      (click)="importStudents()"
      [disabled]="!importStudentModal?.file || !importStudentModal?.school"
    >
      Upload
    </button>
  </mat-dialog-actions>
</div>
<div *ngIf="importPhase === 2">
  <mat-dialog-content *ngIf="importSuccessful">
    <div class="alert-message-popup min-width-100">
      <a class="text-success">
        <mat-icon style="font-size: 40px">check_circle</mat-icon>
      </a>
      <h2 class="h1 my-3">File uploaded successfully !</h2>
      <p class="mb-0" *ngIf="successReport?.imported?.length > 0">
        {{ successReport?.imported?.length }} students successfully imported
      </p>
      <p class="mb-0" *ngIf="successReport?.updated?.length > 0">
        {{ successReport?.updated?.length }} students successfully updated
      </p>
      <p class="text-danger mb-0" *ngIf="successReport?.failed?.length > 0">
        {{ successReport?.failed?.length }} students failed to import
      </p>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end" *ngIf="importSuccessful">
    <mat-icon *ngIf="successReport?.placementScoreAdjustments?.length"
        class="text-warning mb-2" style="font-size: 28px; filter: drop-shadow(0 0 5px #efb30d);"
        [matTooltip]="placementScoreAdjustmentMessage"
        matTooltipClass="placement-score-adjustment-tooltip"
        aria-label="Placement score adjustments"
        >priority_high</mat-icon
      >
    <button mat-button (click)="importPhase = 3" *ngIf="studentDetails">
      View Details
    </button>
    <button
      mat-raised-button
      mat-dialog-close
      color="primary"
      (click)="dialogRef.close(true)"
    >
      Done
    </button>
  </mat-dialog-actions>
  <mat-dialog-content *ngIf="!importSuccessful">
    Uh oh, something went wrong! Please try again
  </mat-dialog-content>
  <mat-dialog-actions align="end" *ngIf="!importSuccessful">
    <button mat-button (click)="dialogRef.close(false)">Dismiss</button>
    <button mat-raised-button color="primary" (click)="resetForm()">
      Try Again
    </button>
  </mat-dialog-actions>
</div>
<div *ngIf="importPhase === 3">
  <mat-dialog-content>
    <div *ngIf="successReport?.imported?.length">
      <p class="modal-text m-0">
        {{ successReport?.imported?.length }} students added
      </p>
      <div class="list-name-scroll">
        <ul class="list-unstyled list-name row">
          <li class="col-md-6 student-report-item" *ngFor="let student of successReport?.imported">
            <span class="student-report-name text"
              >{{ student.first_name }} {{ student.second_name }}
              {{ student.last_name }}</span
            >
            <mat-icon
              *ngIf="getPlacementScoreAdjustmentMessage(student) as adjustmentMessage"
              class="student-report-warning text-warning" style="font-size: 28px; filter: drop-shadow(0 0 5px #efb30d);"
              [matTooltip]="adjustmentMessage"
              matTooltipClass="placement-score-adjustment-tooltip"
              aria-label="Placement score adjustment"
              >priority_high</mat-icon
            >
          </li>
        </ul>
      </div>
    </div>
    <div *ngIf="successReport?.updated?.length">
      <p class="modal-text m-0">
        {{ successReport?.updated?.length }} students updated
      </p>
      <div class="list-name-scroll">
        <ul class="list-unstyled list-name row">
          <li class="col-md-6 student-report-item" *ngFor="let student of successReport?.updated">
            <span class="student-report-name text"
              >{{ student.first_name }} {{ student.second_name }}
              {{ student.last_name }}</span
            >
            <mat-icon
              *ngIf="getPlacementScoreAdjustmentMessage(student) as adjustmentMessage"
              class="student-report-warning text-warning" style="font-size: 28px; filter: drop-shadow(0 0 5px #efb30d);"
              [matTooltip]="adjustmentMessage"
              matTooltipClass="placement-score-adjustment-tooltip"
              aria-label="Placement score adjustment"
              >priority_high</mat-icon
            >
          </li>
        </ul>
      </div>
    </div>
    <div *ngIf="successReport?.failed?.length">
      <p class="modal-text m-0">
        {{ successReport?.failed?.length }} students failed
      </p>
      <div class="list-name-scroll">
        <ul class="list-unstyled list-name row">
          <li class="col-md-6" *ngFor="let status of successReport?.failed">
            <span class="text"
              >{{ status.first_name }} {{ status.second_name }}
              {{ status.last_name }}</span
            >
          </li>
        </ul>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-raised-button color="primary" (click)="dialogRef.close(true)">
      Dismiss
    </button>
  </mat-dialog-actions>
</div>
